export default "__VITE_ASSET__QkZQV5Jm__"